<template>
  <StandardArticle
    :title="title"
    :quote="quote"
    :quote-author="quoteAuthor"
    :preview-image-src="previewImageSrc"
    :preview-image-alt="previewImageAlt"
  >
    <p>For this page I am not going to go into the technicalities of how I built this site. I am currently working on the blog, once done that will be the primary location for technical articles. Instead I will talk a little bit about the motivations and reasoning for the sites existence.</p>

    <h2>Personal Development</h2>
    <p>As much as I love my job and despite working for forward thinking companies, there is only so much you can try new things at work. After all you have products to deliver, deadlines to meet and standards to maintain. As such, any developer that who wants to remain on the cutting edge is going to need a few personal projects where they can try new things without the pressure of our day job. That is my primary reason for taking this project on. I wanted my own little corner of the web. A little playground where I could try things out.</p>

    <img src="@/assets/writing.jpg" alt="Writing" />

    <h2>A Place to write things down.</h2>
    <p>There are many types of learners out there. Some people learn through doing. Some by listening. Some by reading. Me? I learn best by getting stuck in into something, and then brand what I have learned into my brain by writing my down my findings in my own words. This site provides the perfect place to do just that, not only that, it's fast and globally accessible (provided I keep paying my AWS bill) so I'll be able to refer back to it in the years to come.</p>

    <img src="@/assets/teaching.jpg" alt="Teaching" />

    <h2>Sharing the love (not like that... sicko)</h2>
    <p>
      Let's be honest. When you get stuck on something 80% of the time you find the answer on
      <a
        href="https://stackoverflow.com/"
      >StackOverflow</a>. But the amount of times I have stumbled onto someone’s personal site or blog and found an article or tutorial that has saved my bacon. I'm hoping that one of my articles will do the same one day.
    </p>
  </StandardArticle>
</template>

<script>
import StandardArticle from '@/components/article/Standard-Article.vue'

export default {
  name: 'thisSite',
  components: {
    StandardArticle
  },
  data: function () {
    return {
      title: 'This Site',
      quote:
        'The original idea of the web was that it should be a collaborative space where you can communicate through sharing information.',
      quoteAuthor: 'Tim Berners-Lee',
      previewImageSrc: require(`../assets/camera-coffee-composition.jpg`),
      previewImageAlt: 'Planning'
    }
  }
}
</script>
